import React from 'react';
import {
    TextInput,
    DateInput,
    Create,
    SimpleForm,
    required,
    CardActions,
    ListButton,
    Toolbar,
    SaveButton,

} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
import SelectTraining from './SelectTraining'
import Users from './Users'

let ssn = null;

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const TrainingActions = ({props}) => (
    <CardActions style={cardActionStyle}>
        <ListButton basePath={'/trainings'} label='Training List'/>
    </CardActions>
);

const editStyles = {
    root: { alignItems: 'flex-start'},
};


const TrainingToolbar = props => (
    <Toolbar {...props} >
        <SaveButton
            label="save"
            redirect="list"
            submitOnEnter={true}
        />
    </Toolbar>
);

const TrainingCreate =({ classes, ...props }) => (
    
<Create 
    title='Employee Training' 
    {...props}  
    actions={<TrainingActions props={props} />} 
    >
        <SimpleForm  toolbar={<TrainingToolbar />}> 
                <SelectTraining  props={props}/>
                <Users  props={props} />
                <DateInput source="training_date" locales="en-us" label="training Date"  validate={required()}/>
        </SimpleForm>
    </Create>
);

export default withStyles(editStyles)(TrainingCreate);